import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3 flex-shrink-0">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-secondary-700 bg-secondary-100 px-3 py-1.5 rounded-full mb-6">
              / About Superbuy Spreadsheet
            </span>
            <div className="hidden lg:block mt-8">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20collaborative%20workspace%20with%20diverse%20fashion%20trend%20boards%20and%20fabric%20swatches%20spread%20across%20white%20oak%20desk%2C%20natural%20daylight%20from%20floor%20to%20ceiling%20windows%2C%20creative%20studio%20atmosphere%20with%20plants%20and%20contemporary%20furniture%2C%20editorial%20interior%20photography%20with%20inspiring%20energetic%20vibe&width=500&height=600&seq=about-team-v2-01&orientation=portrait"
                alt="Superbuy Spreadsheet research team"
                className="w-full rounded-xl object-cover"
              />
            </div>
          </div>

          <div className="lg:w-2/3">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-8 leading-tight">
              Your Trusted Superbuy Spreadsheet Resource for 2026
            </h2>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
              <p>
                Finding reliable sellers and the best deals on Superbuy can be overwhelming. That is why we created the ultimate <strong>superbuy spreadsheet</strong> — a carefully curated collection of trusted fashion, sneakers, and streetwear sources. Whether you are a beginner or an experienced shopper, our superbuy spreadsheet 2026 edition helps you navigate the platform with confidence.
              </p>
              <p>
                Each category in our superbuy spreadsheet has been verified by our research team with over five years of experience in cross-border shopping. We evaluate sellers based on product quality, shipping speed, customer reviews, and overall reliability. The best superbuy spreadsheet is not just a list — it is your complete shopping companion.
              </p>
              <p>
                From premium sneakers to designer accessories, our superbuy fashion spreadsheet covers every category you need. We regularly update our superbuy spreadsheet to ensure you always have access to the most current and trusted seller information available anywhere online.
              </p>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <Link
                to="/what-is-superbuy-spreadsheet/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
              >
                Read Our Full Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <div className="flex items-center gap-3">
                <div className="flex -space-x-2">
                  <div className="w-10 h-10 rounded-full border-2 border-background-100 bg-secondary-200 flex items-center justify-center overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20male%20fashion%20researcher%20in%20early%20thirties%20with%20charcoal%20gray%20blazer%20against%20soft%20teal%20studio%20background%2C%20confident%20warm%20expression%2C%20modern%20corporate%20portrait%20photography%20with%20rim%20lighting&width=80&height=80&seq=avatar-team-v2-1&orientation=squarish"
                      alt="Team member"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-background-100 bg-secondary-200 flex items-center justify-center overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20female%20sneaker%20analyst%20in%20late%20twenties%20with%20denim%20jacket%20against%20warm%20terracotta%20studio%20background%2C%20friendly%20smile%2C%20modern%20casual%20portrait%20photography%20with%20natural%20window%20light&width=80&height=80&seq=avatar-team-v2-2&orientation=squarish"
                      alt="Team member"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-background-100 bg-secondary-200 flex items-center justify-center overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20male%20streetwear%20curator%20in%20mid%20thirties%20with%20black%20hoodie%20against%20dusty%20rose%20studio%20background%2C%20serious%20creative%20expression%2C%20edgy%20portrait%20photography%20with%20dramatic%20shadow%20play&width=80&height=80&seq=avatar-team-v2-3&orientation=squarish"
                      alt="Team member"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-background-100 bg-secondary-200 flex items-center justify-center overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20female%20luxury%20goods%20expert%20in%20early%20thirties%20with%20ivory%20silk%20blouse%20against%20sage%20green%20studio%20background%2C%20elegant%20warm%20smile%2C%20sophisticated%20portrait%20photography%20with%20golden%20hour%20lighting&width=80&height=80&seq=avatar-team-v2-4&orientation=squarish"
                      alt="Team member"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">Curated by Experts</p>
                  <p className="text-xs text-foreground-500">5+ years researching trusted sellers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}